module.exports = {
	"config": {
		"siteTitle": "Le comparateur de programmes de la France insoumise",
		"siteDescription": "Comparez les programmes des candidats à la présidentielle 2017 avec le programme de la France insoumise : l'Avenir en commun.",
		"linkPrefix": "/comparateur-programme",
		"siteUrl": "https://insoumis.github.io"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "",
				"stem": "_template",
				"path": "_template.js"
			},
			"requirePath": "_template.js",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html",
				"id": "notfound"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "about.md",
				"ext": "md",
				"name": "about",
				"extname": ".md",
				"basename": "about.md",
				"dirname": "",
				"stem": "about",
				"path": "about.md"
			},
			"requirePath": "about.md",
			"path": "/about/",
			"data": {
				"path": "/about",
				"id": "about"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "contact.js",
				"ext": "js",
				"name": "contact",
				"extname": ".js",
				"basename": "contact.js",
				"dirname": "",
				"stem": "contact",
				"path": "contact.js"
			},
			"requirePath": "contact.js",
			"path": "/contact/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js"
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "versus",
				"base": "en-marche.toml",
				"ext": "toml",
				"name": "en-marche",
				"extname": ".toml",
				"basename": "en-marche.toml",
				"dirname": "versus",
				"stem": "en-marche",
				"path": "versus/en-marche.toml"
			},
			"requirePath": "versus/en-marche.toml",
			"path": "/versus/en-marche/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "versus",
				"base": "front-national.toml",
				"ext": "toml",
				"name": "front-national",
				"extname": ".toml",
				"basename": "front-national.toml",
				"dirname": "versus",
				"stem": "front-national",
				"path": "versus/front-national.toml"
			},
			"requirePath": "versus/front-national.toml",
			"path": "/versus/front-national/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "versus",
				"base": "les-republicains.toml",
				"ext": "toml",
				"name": "les-republicains",
				"extname": ".toml",
				"basename": "les-republicains.toml",
				"dirname": "versus",
				"stem": "les-republicains",
				"path": "versus/les-republicains.toml"
			},
			"requirePath": "versus/les-republicains.toml",
			"path": "/versus/les-republicains/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "versus",
				"base": "parti-socialiste.toml",
				"ext": "toml",
				"name": "parti-socialiste",
				"extname": ".toml",
				"basename": "parti-socialiste.toml",
				"dirname": "versus",
				"stem": "parti-socialiste",
				"path": "versus/parti-socialiste.toml"
			},
			"requirePath": "versus/parti-socialiste.toml",
			"path": "/versus/parti-socialiste/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 385
// module chunks = 0